// extracted by mini-css-extract-plugin
module.exports = {"replies":"tweet-replies_replies___z0dm","link":"tweet-replies_link__iPVud","text":"tweet-replies_text__AU_p2"};